module.exports = __webpack_public_path__ + "static/media/cq_editor_lista_puntata.a5d83d63.svg";